import Text from '@components/Text';
import s from './StaticContentHeader.module.scss';

const StaticContentHeader = () => (
  <div className={s.root}>
    <Text size={'small'} inline className={s.text}>
      г. Москва
    </Text>
    <Text size={'small'} inline className={s.text}>
      8 марта 2022 года
    </Text>
  </div>
);

export default StaticContentHeader;
